import {
  ASSIGNMENT_STATE_MISSING,
  ASSIGNMENT_STATE_NR,
  ASSIGNMENT_STATE_POST,
  ASSIGNMENT_STATE_TEAM_KO,
  ASSIGNMENT_STATE_TEAM_OK,
  ASSIGNMENT_STATE_TEAM_OK_NR,
} from 'lib/assignmentStates'
import { STEP_STATE_COMPLETED_WITH_ERRORS, STEP_STATE_OPEN } from 'lib/stepper'
import {
  CAR_CHOICE_ACCEPTED,
  CAR_CHOICE_ACCEPTED_WITH_REPRICE,
} from 'lib/carChoicesLib'

import {
  FILTER_ASSIGNMENT_TYPE_ASSIGNED_CHOICE,
  FILTER_ASSIGNMENT_TYPE_NOT_ASSIGNED_CHOICE,
  FILTER_ASSIGNMENT_TYPE_TO_BE_ASSIGNED_CHOICE,
} from 'hooks/useCarsFilters'

export const ASSIGNMENT_ROOT = 'assignment'

export const ASSIGNMENT_STEP_PUBLICATION = 'publication'
export const ASSIGNMENT_STEP_CAR_ASSIGNMENT = 'car-assignment'
export const ASSIGNMENT_STEP_SUMMARY = 'summary'
export const ASSIGNMENT_CAR_DETAILS = 'car-details'

export const ASSIGNMENT_STEPS_LIST = [
  ASSIGNMENT_STEP_PUBLICATION,
  ASSIGNMENT_STEP_CAR_ASSIGNMENT,
  ASSIGNMENT_STEP_SUMMARY,
]

export const ASSIGNMENT_CAP_MANAGEMENT_DELTA_EQUAL = 'equal'
export const ASSIGNMENT_CAP_MANAGEMENT_DELTA_UNDER = 'under'
export const ASSIGNMENT_CAP_MANAGEMENT_DELTA_OVER = 'over'

export const ASSIGNMENT_CAP_MANAGEMENT_DELTA_LIST = [
  ASSIGNMENT_CAP_MANAGEMENT_DELTA_EQUAL,
  ASSIGNMENT_CAP_MANAGEMENT_DELTA_UNDER,
  ASSIGNMENT_CAP_MANAGEMENT_DELTA_OVER,
]

export const getAssignmentStepUrl = (sessionId, step, plate) =>
  plate
    ? `/${ASSIGNMENT_ROOT}/${sessionId}/${step}/${plate}`
    : `/${ASSIGNMENT_ROOT}/${sessionId}/${step}`

export const getLastAssignementStep = (sessionId, steps) =>
  `/${ASSIGNMENT_ROOT}/${sessionId}/${getLastAssignmentStep(steps)}`

export const getLastAssignmentStep = (steps) =>
  steps.find(
    (step) =>
      step.state === STEP_STATE_OPEN ||
      step.state === STEP_STATE_COMPLETED_WITH_ERRORS
  )?.step || ASSIGNMENT_STEP_PUBLICATION

export const checkAssignment = (session) => !!session.assignmentStartedAt

export const getAssignmentStatusColor = (status) =>
  [ASSIGNMENT_STATE_NR, ASSIGNMENT_STATE_MISSING].includes(status)
    ? 'error'
    : [ASSIGNMENT_STATE_TEAM_KO].includes(status)
    ? 'textPrimary'
    : '#2BB5AE'

export const checkRecapChoice = (car, partnerId, type) => {
  const camelCaseType =
    type === CAR_CHOICE_ACCEPTED
      ? 'acceptedChoice'
      : type === CAR_CHOICE_ACCEPTED_WITH_REPRICE
      ? 'acceptedWithRepriceChoice'
      : undefined

  return type !== CAR_CHOICE_ACCEPTED &&
    type !== CAR_CHOICE_ACCEPTED_WITH_REPRICE
    ? (!car.acceptedChoiceTotal ||
        (partnerId && !car.acceptedChoiceList.includes(partnerId))) &&
        (!car.acceptedWithRepriceChoiceTotal ||
          (partnerId && !car.acceptedWithRepriceChoiceList.includes(partnerId)))
    : car?.[`${camelCaseType}Total`] &&
        (partnerId ? car?.[`${camelCaseType}List`].includes(partnerId) : true)
}

export const checkNotAssigned = (car, partnerId) =>
  [ASSIGNMENT_STATE_TEAM_KO].includes(car.assignmentState) &&
  !car.assignedPartnerId

export const checkAssigned = (car, partnerId) =>
  [ASSIGNMENT_STATE_TEAM_OK, ASSIGNMENT_STATE_POST].includes(
    car.assignmentState
  ) && (partnerId ? car.assignedPartnerId === partnerId : true)

export const checkToBeAssigned = (car, partnerId) =>
  [ASSIGNMENT_STATE_MISSING, ASSIGNMENT_STATE_NR].includes(car.assignmentState)

export const getAssignmentRecapValues = (cars, partnerId) => {
  const result = cars.reduce(
    (previous, car) => ({
      [CAR_CHOICE_ACCEPTED]:
        (previous[CAR_CHOICE_ACCEPTED] || 0) +
        (checkRecapChoice(car, partnerId, CAR_CHOICE_ACCEPTED) ? 1 : 0),
      [CAR_CHOICE_ACCEPTED_WITH_REPRICE]:
        (previous[CAR_CHOICE_ACCEPTED_WITH_REPRICE] || 0) +
        (checkRecapChoice(car, partnerId, CAR_CHOICE_ACCEPTED_WITH_REPRICE)
          ? 1
          : 0),
      notChosen:
        (previous.notChosen || 0) + (checkRecapChoice(car, partnerId) ? 1 : 0),
      [FILTER_ASSIGNMENT_TYPE_NOT_ASSIGNED_CHOICE]:
        (previous[FILTER_ASSIGNMENT_TYPE_NOT_ASSIGNED_CHOICE] || 0) +
        (checkNotAssigned(car, partnerId) ? 1 : 0),
      [FILTER_ASSIGNMENT_TYPE_ASSIGNED_CHOICE]:
        (previous[FILTER_ASSIGNMENT_TYPE_ASSIGNED_CHOICE] || 0) +
        (checkAssigned(car, partnerId) ? 1 : 0),
      [FILTER_ASSIGNMENT_TYPE_TO_BE_ASSIGNED_CHOICE]:
        (previous[FILTER_ASSIGNMENT_TYPE_TO_BE_ASSIGNED_CHOICE] || 0) +
        (checkToBeAssigned(car, partnerId) ? 1 : 0),
    }),
    {}
  )
  result.total = cars.length

  return result
}

export const getAssignmentState = (car) =>
  car?.assignedPartnerId === null
    ? car?.assignmentState === ASSIGNMENT_STATE_NR
      ? ASSIGNMENT_STATE_NR
      : car?.assignmentState === ASSIGNMENT_STATE_TEAM_KO
      ? ASSIGNMENT_STATE_TEAM_KO
      : ASSIGNMENT_STATE_MISSING
    : car?.autoAssignmentState === ASSIGNMENT_STATE_NR
    ? ASSIGNMENT_STATE_TEAM_OK_NR
    : ASSIGNMENT_STATE_TEAM_OK
